export const DELETION_DIALOG_TITLE = 'deletion-dialog.title';
export const DELETION_DIALOG_CONFIRM_BUTTON_LABEL = 'deletion-dialog.confirm-button-label';
export const DELETION_DIALOG_DISMISS_BUTTON_LABEL = 'deletion-dialog.dismiss-button-label';
export const DELETION_DIALOG_ICON_ALT = 'deletion-dialog.icon-alt';
